module.exports = __webpack_public_path__ + "img/Objective.df621869.png";